var returnPointsCarousel = (function () {


  var setUpcarousel = function () {

    var $carousel = $('.c-return-points-widget-carousel');
    var $carouselContainer = $carousel.find('.rp-slick-carousel__container');
    var settings = {
      autoplay: false,
      accessibility: true,
      prevArrow: false,
      nextArrow: false,
      mobileFirst: true,
      touchMove:true,
      speed: 300,
      dotsClass: 'o-list-inline u-margin-bottom-small carousel-dots',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }, 
        {
          breakpoint: 680,
          settings: {
            dots:true,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 319,
          settings: {
            dots:true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
  
    if ($carouselContainer.length) {
      $carouselContainer.slick(settings);
    }
  };

  var init = function () {
    setUpcarousel();
  };

  return {
    init: init
  };
})();

export default returnPointsCarousel;



// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/returnPointsCarousel.js